import { IBar, IBarline, IKeyChange, IScore, ISignature } from "../../../../../common/types";
import parseBeams, { IGroup } from "../../../Score/score-display/Bar/beaming";
import { getLastSignature } from "../../../Score/score-display/utils";

export default (score: IScore) => {
    const newBars: (IBar | null)[] = [];
    const correctBarlines: number[] = [];
    const newBarlines: IBarline[] = [];
    const newSignatures: ISignature[] = [];
    const newKeyChanges: IKeyChange[] = [];
    let upbeatLength = 0;
    score.bars.forEach((bar, barIndex) => {
        if (!bar) {
            newBars.push(null);
            return;
        };
        const { notes } = bar;
        const signature = getLastSignature(score.signatures, barIndex, score.bars as IBar[], score);
        const groups = parseBeams({ notes, signature, pitchPositions: [], onlyGroup: true }) as IGroup[][];
        if (barIndex === 0) {
            if (groups[0].length === 0) {
                groups.shift();
            }
            upbeatLength = groups.length;
        }
        const existingSignature = score.signatures.find(sig => sig.bar === barIndex);
        if (existingSignature) {
            newSignatures.push({
                ...existingSignature,
                bar: newBars.length,
            });
        }
        const existingKeyChange = (score.keyChanges || []).find(kc => kc.bar === barIndex);
        if (existingKeyChange) {
            newKeyChanges.push({
                ...existingKeyChange,
                bar: newBars.length,
            });
        }

        groups.forEach(group => {
            newBars.push({ notes: group.map(g => g.note) });
        });
        correctBarlines.push(newBars.length - 1);
        const barline = score.barlines.find(barline => barline.bar === barIndex);
        if (barline) {
            newBarlines.push({
                ...barline,
                bar: newBars.length - 1,
            });
        }
    });
    if (!(newBarlines.findIndex(bl => bl.bar === newBars.length - 1) !== -1 && newBarlines.find(bl => bl.bar === newBars.length - 1)!.trunc)) {
        correctBarlines.pop();
    }
    const lastBarline = newBarlines[newBarlines.length - 1];
    if (!!lastBarline && newBars.length - 1 === lastBarline.bar && lastBarline.trunc) {
        newBars.push({ notes: [] });
    }
    return {
        score: {
            ...score,
            bars: newBars,
            barlines: newBarlines,
            signatures: newSignatures,
            keyChanges: newKeyChanges,
        },
        correctBarlines,
        upbeatLength,
    };
}